// extracted by mini-css-extract-plugin
module.exports = {"promoBanner":"PromoBannerContainer_promoBanner__fVz_P","promoBannerWithoutBorder":"PromoBannerContainer_promoBannerWithoutBorder__99_dI"};